export default __webpack_public_path__ + "static/media/box-arrow-in-right.bf7998fe.svg";